import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  loadMultipleOptions,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getUserService } from "features/users/userApi";
import { PartnerFeedItem, getPartnerFeedService } from "./partnerFeedApi";

export interface UsePartnerFeedFormProps extends GridModalFormProps {}

export interface UsePartnerFeedFormReturnType extends UseFormReturnType<
  PartnerFeedItem,
  any
> {}

export default function usePartnerFeedForm({
  id,
  afterSave,
  defaultValues,
}: UsePartnerFeedFormProps): UsePartnerFeedFormReturnType {
  const params = useParams<"partner_feed_id">();
  const scope = {};
  const service = getPartnerFeedService(scope);

  const form = useForm<PartnerFeedItem, any>({
    id: params.partner_feed_id || id,
    translationCategory: "PartnerFeed",
    ignoreNavigateAfterCreate: true,
    rules: {
      title: Validator.rule.string().required(),
    },
    afterSave,
    defaultValues,
    ...service,
    loadOptions: loadMultipleOptions({
      account_manager_id: () => getUserService().loadAutocomplete(),
    }),
  });

  return form;
}
